import { useContext } from 'react';
import * as R from 'ramda';

import { Icon } from '@atom/mui';
import { ErrorOutlineIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import ElementInfoBox from './ElementInfoBox';
import MoveElementModalContext from './MoveElementModalContext';

import classes from './moveElement.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const ConfirmStep = () => {
  const { element, destinationAssetPath, rootAsset } = useContext(
    MoveElementModalContext,
  );

  const fromAssetDisplay = element.ancestors.map(item => item.name).join(' / ');
  const toAssetDisplay = destinationAssetPath
    .map(item => item.name)
    .join(' / ');
  const toAssetId = R.head(destinationAssetPath)?.id;

  return (
    <div className={classes.listContainer}>
      <div className={classes.confirmHeader}>
        Are you sure you want to move this sub item?
      </div>
      <ElementInfoBox
        element={element}
        fromAssetDisplay={fromAssetDisplay}
        fromAssetId={rootAsset.id}
        toAssetDisplay={toAssetDisplay}
        toAssetId={toAssetId}
      />
      <div className={classes.infoSection}>
        <Icon
          style={styles.icon}
          color={colors.brand.blue}
          icon={ErrorOutlineIcon}
        />
        <div>
          <div>Moving sub items will also:</div>
          <ul className={classes.list}>
            <li>
              Move any nested sub items if they exist, media (photos, documents,
              and videos), and pending changes.
            </li>
            <li>Reassign open work to the new parent.</li>
            <li>Keep closed work with the original parent.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConfirmStep;
